module["exports"] = [
  "Josep",
  "Ángel",
  "Daniel",
  "Manuel",
  "Pedro",
  "Salvador",
  "Rubén",
  "Iván",
  "Miguel",
  "Jorge",
  "Sergi",
  "Josep",
  "Ricardo",
  "Carles",
  "Jordi",
  "Manuel"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/es/name/male_first_name.js
// module id = 2822
// module chunks = 1610